import { render, staticRenderFns } from "./OverallChartRating.vue?vue&type=template&id=4f4e70a8&scoped=true"
import script from "./OverallChartRating.vue?vue&type=script&lang=js"
export * from "./OverallChartRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4e70a8",
  null
  
)

export default component.exports